import { useCallback } from "react"
import { useMutation } from "@tanstack/react-query"
// context
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
// api
import { updateUserData, UpdateUserDataResponse, UpdateUserDataRequest } from "api"
// types
import { User } from "types/user"

export const useNotifications = () => {
  const {
    user: { documentId, userProfileDocumentId, subscribeNewCourses, subscribeYourQuestionAnswered },
    setUser,
  } = useAuthenticationContext()

  const { isLoading, mutate: updateUserDataMutate } = useMutation<
    UpdateUserDataResponse,
    unknown,
    UpdateUserDataRequest
  >({
    mutationFn: updateUserData,
    onSuccess: ({ data }: any) => {
      setUser((prev: User) => ({
        ...prev,
        subscribeNewCourses: !!data?.subscribeNewCourses,
        subscribeYourQuestionAnswered: !!data?.subscribeYourQuestionAnswered,
      }))
    },
  })

  const handleToggleNewCourseSubscribe = useCallback((e: React.SyntheticEvent, value: boolean) => {
    updateUserDataMutate({ documentId, userProfileDocumentId, subscribeNewCourses: value })
  }, [])

  const handleToggleQuestionAnsweredSubscribe = useCallback((e: React.SyntheticEvent, value: boolean) => {
    updateUserDataMutate({ documentId, userProfileDocumentId, subscribeYourQuestionAnswered: value })
  }, [])

  return {
    subscribeNewCourses,
    subscribeYourQuestionAnswered,
    handleToggleNewCourseSubscribe,
    handleToggleQuestionAnsweredSubscribe,
    isLoading,
  }
}
